import { useContext } from 'react'
import { NewFormIdContext } from '../context/NewFormIdContext'

const useNewFormId = () => useContext(NewFormIdContext)

export default useNewFormId